<div class="loader"><span></span> <span></span> <span></span> <span></span> <span></span></div>
